/**
 * State Name
 */
export const CAMPAIGN_MEMBERS = 'CAMPAIGN_MEMBERS';
